export type NormalizedOrganizationStatus =
  | 'ACTIVE'
  | 'TRIAL'
  | 'SUSPENDED'
  | 'CANCELED'
  | 'Não configurado';

interface OrganizationStatusLike {
  status?: string | null;
}

export function normalizeOrganizationStatus(org?: OrganizationStatusLike | null): NormalizedOrganizationStatus {
  const rawStatus = String(org?.status || '').trim().toLowerCase();

  if (!rawStatus) {
    return 'Não configurado';
  }

  if (rawStatus === 'active' || rawStatus === 'enabled' || rawStatus === 'paid') {
    return 'ACTIVE';
  }

  if (rawStatus === 'trial' || rawStatus === 'in_trial' || rawStatus === 'trialing') {
    return 'TRIAL';
  }

  if (rawStatus === 'suspended' || rawStatus === 'blocked' || rawStatus === 'past_due' || rawStatus === 'paused') {
    return 'SUSPENDED';
  }

  if (rawStatus === 'canceled' || rawStatus === 'cancelled' || rawStatus === 'expired' || rawStatus === 'inactive') {
    return 'CANCELED';
  }

  return 'Não configurado';
}
